module.exports = __webpack_public_path__ + "assets/img/close-circle.9134ac88.svg";